import { jsx } from 'panel';
import { QueryBlockEl } from 'common/widgets/query-block';
export function template() {
  const {
    addingBlock,
    prefixRenderer,
    stagingSelected
  } = this.state;
  const selected = stagingSelected || this.attr("selected");

  const MultiBlockItem = _ref => {
    let {
      selection,
      idx
    } = _ref;
    const serializedSelection = JSON.stringify(selection);
    return jsx(null, null, prefixRenderer ? jsx("div", {
      sel: '.mp-query-multi-block-prefix'
    }, prefixRenderer(idx, selection)) : null, jsx("div", {
      sel: '.mp-query-multi-block-item',
      key: serializedSelection
    }, jsx(QueryBlockEl, {
      attrs: this.helpers.getQueryBlockAttrs({
        elref: "queryBlock",
        'prefix-label': this.attr(idx === 0 ? "first-block-prefix" : "block-prefix"),
        removable: true,
        selected: serializedSelection
      }),
      on: {
        remove: () => this.helpers.removeSelection(selection),
        select: ev => this.helpers.modifySelection(idx, ev),
        track: this.helpers.preventTracking
      }
    })));
  };

  return jsx("div", {
    sel: '.mp-query-multi-block',
    class: {
      ["".concat(this.attr("layout"), "-layout")]: true
    }
  }, selected.map((selection, idx) => jsx(MultiBlockItem, {
    selection: selection,
    idx: idx
  })), !this.attr("adding-disabled") && this.helpers.canAddMore() ? jsx(null, null, prefixRenderer ? jsx("div", {
    sel: '.mp-query-multi-block-prefix'
  }, prefixRenderer(selected.length, null)) : null, jsx("div", {
    sel: '.mp-query-multi-block-item',
    key: 'new-block-item'
  }, jsx(QueryBlockEl, {
    attrs: this.helpers.getQueryBlockAttrs({
      'selector-icon': this.attr("button-icon"),
      'selector-type': this.attr("button-selector-type"),
      theme: this.attr("button-selector-theme"),
      label: this.helpers.buttonText(),
      'input-only': true,
      tooltip: this.attr("tooltip"),
      open: this.attr("button-open") || addingBlock,
      elref: "addBlock"
    }),
    dataset: {
      key: "new-block"
    },
    on: {
      select: this.helpers.commitNewBlock,
      track: this.helpers.preventTracking,
      open: () => this.helpers.setAddingBlock(true),
      close: this.helpers.onAddItemBlockClose
    }
  }))) : null);
}